export interface Course {
  id: string;
  title: string;
  instructor: string;
  duration: string;
  lessons: number;
  category: string;
  description: string;
  level: string;
  isNew?: boolean;
  image: string;
}

export interface Publication {
  id: string;
  title: string;
  category: string;
  date: string;
  summary: string;
  fileType: string;
  fileSize: string;
  pages: number;
  isNew?: boolean;
  image: string;
}

export interface ExternalLink {
  id: string;
  title: string;
  description: string;
  url: string;
  category: string;
  icon: string;
}

export const courses: Course[] = [
  {
    id: "c1",
    title: "生成式 AI 實務操作課程",
    instructor: "李明軒 博士 · TAIAA 技術委員",
    duration: "8 小時",
    lessons: 12,
    category: "技術實作",
    description:
      "從提示工程到進階應用，系統學習生成式 AI 工具的操作技巧。涵蓋文字生成、圖像創作、程式輔助與企業導入策略，適合各產業專業人士。",
    level: "入門",
    isNew: true,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20online%20course%20interface%20on%20laptop%20screen%20showing%20generative%20AI%20tools%20and%20chatbot%20conversation%2C%20professional%20e-learning%20environment%2C%20clean%20minimalist%20workspace%2C%20soft%20ambient%20lighting%2C%20technology%20education%20concept%2C%20navy%20blue%20and%20silver%20white%20color%20scheme%2C%20high%20quality%20editorial%20photography&width=800&height=600&seq=taiaa-course-1&orientation=landscape",
  },
  {
    id: "c2",
    title: "AI 倫理與負責任應用",
    instructor: "陳思穎 教授 · 台大法律系",
    duration: "6 小時",
    lessons: 8,
    category: "治理與倫理",
    description:
      "深入探討 AI 倫理框架、歐盟 AI 法案、資料隱私與演算法公平性。協助企業與開發者建立負責任 AI 的實務認知與合規策略。",
    level: "中階",
    isNew: true,
    image:
      "https://readdy.ai/api/search-image?query=Ethical%20AI%20and%20responsible%20technology%20concept%20visualization%2C%20abstract%20balance%20scale%20with%20digital%20brain%20and%20circuit%20patterns%2C%20professional%20educational%20design%2C%20dark%20navy%20background%20with%20silver%20white%20accents%2C%20modern%20corporate%20training%20aesthetic%2C%20clean%20minimalist%20composition&width=800&height=600&seq=taiaa-course-2&orientation=landscape",
  },
  {
    id: "c3",
    title: "企業 AI 導入管理實務",
    instructor: "王偉誠 總監 · 緯創資通",
    duration: "10 小時",
    lessons: 16,
    category: "管理策略",
    description:
      "針對企業決策者與專案經理設計，從需求評估、技術選型、團隊建構到落地推動的完整管理框架。收錄多家企業導入實戰案例。",
    level: "中階",
    image:
      "https://readdy.ai/api/search-image?query=Corporate%20AI%20strategy%20meeting%20with%20executives%20reviewing%20digital%20transformation%20roadmap%20on%20large%20screen%2C%20modern%20boardroom%20with%20glass%20walls%2C%20professional%20business%20atmosphere%2C%20navy%20blue%20and%20white%20interior%2C%20clean%20minimalist%20corporate%20photography%2C%20technology%20leadership%20concept&width=800&height=600&seq=taiaa-course-3&orientation=landscape",
  },
  {
    id: "c4",
    title: "AI 視覺辨識入門與實作",
    instructor: "林雅婷 工程師 · Appier",
    duration: "12 小時",
    lessons: 20,
    category: "技術實作",
    description:
      "從圖像分類到物件偵測，手把手帶領學員掌握深度學習視覺辨識的核心概念與實作技能。包含 Python、TensorFlow 實作專案。",
    level: "入門",
    image:
      "https://readdy.ai/api/search-image?query=Computer%20vision%20and%20AI%20image%20recognition%20concept%2C%20abstract%20facial%20recognition%20grid%20with%20data%20points%20overlay%2C%20futuristic%20digital%20interface%2C%20dark%20background%20with%20glowing%20neural%20network%20patterns%2C%20modern%20technology%20education%20aesthetic%2C%20navy%20blue%20and%20silver%20accents%2C%20clean%20professional%20design&width=800&height=600&seq=taiaa-course-4&orientation=landscape",
  },
  {
    id: "c5",
    title: "金融業 AI 風險管理",
    instructor: "張志宏 處長 · 玉山銀行",
    duration: "6 小時",
    lessons: 10,
    category: "產業應用",
    description:
      "聚焦 AI 在金融業的風險管理、反詐騙偵測與投資決策支援。分享金融監管合規要求與實務落地經驗，適合金融業從業人員。",
    level: "中階",
    image:
      "https://readdy.ai/api/search-image?query=Financial%20technology%20and%20AI%20risk%20management%20concept%2C%20abstract%20data%20visualization%20with%20stock%20market%20charts%20and%20risk%20indicators%2C%20modern%20fintech%20dashboard%20interface%2C%20dark%20navy%20background%20with%20glowing%20data%20streams%2C%20professional%20banking%20technology%20aesthetic%2C%20clean%20minimalist%20corporate%20design&width=800&height=600&seq=taiaa-course-5&orientation=landscape",
  },
  {
    id: "c6",
    title: "智慧製造 AI 品質檢測",
    instructor: "趙建國 經理 · 工研院",
    duration: "8 小時",
    lessons: 14,
    category: "產業應用",
    description:
      "探討 AI 在製造業品質檢測、預測性維護與生產優化的實務應用。包含 AOI 視覺檢測、異常偵測與數位孿生入門實作。",
    level: "中階",
    image:
      "https://readdy.ai/api/search-image?query=Smart%20manufacturing%20factory%20floor%20with%20robotic%20arms%20and%20AI%20quality%20inspection%20system%2C%20digital%20twin%20visualization%20on%20large%20screens%2C%20clean%20industrial%20environment%20with%20blue%20ambient%20lighting%2C%20advanced%20manufacturing%20technology%20concept%2C%20professional%20industrial%20photography%2C%20modern%20automation%20aesthetic%2C%20navy%20and%20silver%20tones&width=800&height=600&seq=taiaa-course-6&orientation=landscape",
  },
];

export const courseCategories = [
  { key: "all", label: "全部課程" },
  { key: "技術實作", label: "技術實作" },
  { key: "管理策略", label: "管理策略" },
  { key: "治理與倫理", label: "治理與倫理" },
  { key: "產業應用", label: "產業應用" },
];

export const publications: Publication[] = [
  {
    id: "p1",
    title: "2025 台灣 AI 產業應用白皮書",
    category: "白皮書",
    date: "2025.05",
    summary:
      "深入分析台灣各產業 AI 應用現況、挑戰與機會，涵蓋製造、金融、醫療、零售與教育五大領域，為政策制定與企業決策提供參考依據。",
    fileType: "PDF",
    fileSize: "12.8 MB",
    pages: 180,
    isNew: true,
    image:
      "https://readdy.ai/api/search-image?query=Professional%20white%20paper%20document%20cover%20design%20with%20abstract%20AI%20network%20visualization%2C%20elegant%20minimalist%20layout%2C%20navy%20blue%20and%20silver%20white%20color%20scheme%2C%20clean%20corporate%20report%20aesthetic%2C%20modern%20typography%2C%20data%20visualization%20elements%2C%20high-end%20editorial%20design&width=600&height=800&seq=taiaa-pub-1&orientation=portrait",
  },
  {
    id: "p2",
    title: "生成式 AI 企業導入指南",
    category: "研究報告",
    date: "2025.04",
    summary:
      "針對企業導入生成式 AI 的實務指南，涵蓋需求評估、技術選型、倫理考量與落地策略，收錄 15 個標竿案例。",
    fileType: "PDF",
    fileSize: "8.4 MB",
    pages: 96,
    isNew: true,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20technology%20research%20report%20cover%20with%20generative%20AI%20concept%20art%2C%20neural%20network%20patterns%2C%20futuristic%20abstract%20design%2C%20professional%20corporate%20document%20aesthetic%2C%20dark%20navy%20background%20with%20glowing%20data%20streams%2C%20clean%20typography%20layout&width=600&height=800&seq=taiaa-pub-2&orientation=portrait",
  },
  {
    id: "p3",
    title: "TAIAA 2025 第一季會刊",
    category: "會刊",
    date: "2025.03",
    summary:
      "收錄協會近期活動紀錄、會員專訪、產業趨勢觀察與國際交流動態，呈現 TAIAA 生態系最新發展。",
    fileType: "PDF",
    fileSize: "6.2 MB",
    pages: 48,
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20magazine%20cover%20design%20with%20modern%20typography%2C%20professional%20association%20newsletter%20layout%2C%20abstract%20geometric%20shapes%2C%20navy%20blue%20and%20white%20color%20palette%2C%20clean%20editorial%20design%2C%20sophisticated%20corporate%20publication%20aesthetic&width=600&height=800&seq=taiaa-pub-3&orientation=portrait",
  },
  {
    id: "p4",
    title: "AI 人才培育與認證體系規劃報告",
    category: "研究報告",
    date: "2025.02",
    summary:
      "分析台灣 AI 人才供需現況，提出人才培育藍圖與專業認證框架建議，涵蓋技術、應用與治理三大能力面向。",
    fileType: "PDF",
    fileSize: "5.7 MB",
    pages: 72,
    image:
      "https://readdy.ai/api/search-image?query=Education%20and%20talent%20development%20concept%20document%20cover%2C%20abstract%20human%20head%20silhouette%20with%20digital%20brain%20patterns%2C%20professional%20research%20report%20design%2C%20navy%20and%20silver%20color%20scheme%2C%20modern%20corporate%20aesthetic%2C%20clean%20minimalist%20layout&width=600&height=800&seq=taiaa-pub-4&orientation=portrait",
  },
  {
    id: "p5",
    title: "2024 台灣 AI 產業應用白皮書",
    category: "白皮書",
    date: "2024.12",
    summary:
      "首份全面梳理台灣 AI 產業生態系的白皮書，收錄產業調查數據、企業導入現況分析與政策建議。",
    fileType: "PDF",
    fileSize: "15.3 MB",
    pages: 220,
    image:
      "https://readdy.ai/api/search-image?query=Professional%20annual%20report%20cover%20with%20Taiwan%20island%20silhouette%20and%20technology%20network%20visualization%2C%20abstract%20data%20flow%20patterns%2C%20dark%20navy%20background%2C%20elegant%20corporate%20document%20design%2C%20silver%20white%20accents%2C%20modern%20editorial%20layout&width=600&height=800&seq=taiaa-pub-5&orientation=portrait",
  },
  {
    id: "p6",
    title: "負責任 AI 應用框架與實務指引",
    category: "研究報告",
    date: "2024.09",
    summary:
      "彙整國際 AI 倫理框架與治理標準，針對台灣產業情境提出可操作的負責任 AI 應用檢核表與實務指引。",
    fileType: "PDF",
    fileSize: "4.9 MB",
    pages: 64,
    image:
      "https://readdy.ai/api/search-image?query=Ethical%20AI%20framework%20concept%20document%20cover%2C%20abstract%20balance%20scale%20with%20digital%20elements%2C%20professional%20governance%20report%20design%2C%20navy%20blue%20and%20white%20color%20palette%2C%20clean%20minimalist%20corporate%20aesthetic%2C%20modern%20typography%2C%20trust%20and%20responsibility%20symbolism&width=600&height=800&seq=taiaa-pub-6&orientation=portrait",
  },
  {
    id: "p7",
    title: "2024 AI 產業應用高峰論壇紀錄",
    category: "活動紀錄",
    date: "2024.08",
    summary:
      "收錄論壇專題演講簡報、圓桌論壇對話紀錄與產業對接成果，涵蓋製造、金融、醫療與教育四大主題。",
    fileType: "PDF",
    fileSize: "18.5 MB",
    pages: 156,
    image:
      "https://readdy.ai/api/search-image?query=Conference%20proceedings%20document%20cover%20with%20modern%20auditorium%20stage%20and%20speaker%20silhouette%2C%20professional%20event%20documentation%20design%2C%20navy%20blue%20and%20silver%20tones%2C%20clean%20corporate%20aesthetic%2C%20abstract%20spotlight%20and%20stage%20elements%2C%20editorial%20layout&width=600&height=800&seq=taiaa-pub-7&orientation=portrait",
  },
  {
    id: "p8",
    title: "中小企業 AI 導入評估工具包",
    category: "簡報",
    date: "2024.06",
    summary:
      "專為中小企業設計的 AI 導入自評工具，包含需求分析模板、技術選型檢核表與成本效益評估框架。",
    fileType: "PPT",
    fileSize: "3.2 MB",
    pages: 42,
    image:
      "https://readdy.ai/api/search-image?query=Small%20business%20digital%20transformation%20toolkit%20document%20cover%2C%20abstract%20puzzle%20pieces%20forming%20digital%20brain%2C%20professional%20presentation%20template%20design%2C%20navy%20and%20white%20color%20scheme%2C%20clean%20minimalist%20corporate%20aesthetic%2C%20modern%20business%20infographic%20style&width=600&height=800&seq=taiaa-pub-8&orientation=portrait",
  },
  {
    id: "p9",
    title: "TAIAA 2024 第二季會刊",
    category: "會刊",
    date: "2024.06",
    summary:
      "聚焦國際 AI 治理趨勢、會員企業導入案例分享與協會活動回顧，收錄會員交流沙龍精彩對話。",
    fileType: "PDF",
    fileSize: "5.8 MB",
    pages: 44,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20quarterly%20newsletter%20cover%20with%20abstract%20global%20network%20connections%2C%20professional%20association%20publication%20design%2C%20navy%20blue%20and%20silver%20white%20palette%2C%20clean%20editorial%20typography%2C%20sophisticated%20corporate%20magazine%20aesthetic%2C%20geometric%20shapes&width=600&height=800&seq=taiaa-pub-9&orientation=portrait",
  },
];

export const pubCategories = [
  { key: "all", label: "全部資源" },
  { key: "白皮書", label: "白皮書" },
  { key: "研究報告", label: "研究報告" },
  { key: "會刊", label: "會刊" },
  { key: "活動紀錄", label: "活動紀錄" },
  { key: "簡報", label: "簡報" },
];

export const externalLinks: ExternalLink[] = [
  {
    id: "l1",
    title: "數位發展部",
    description: "台灣數位政策與法規主管機關，發布 AI 相關政策與監管框架。",
    url: "https://moda.gov.tw",
    category: "政府單位",
    icon: "ri-government-line",
  },
  {
    id: "l2",
    title: "經濟部產業發展署",
    description: "推動產業創新與技術升級，發布產業輔導與 AI 應用相關計畫。",
    url: "https://www.ida.gov.tw",
    category: "政府單位",
    icon: "ri-building-4-line",
  },
  {
    id: "l3",
    title: "國家科學及技術委員會",
    description: "國家科技政策規劃與研究發展推動，涵蓋 AI 前瞻研究計畫。",
    url: "https://www.nstc.gov.tw",
    category: "政府單位",
    icon: "ri-graduation-cap-line",
  },
  {
    id: "l4",
    title: "AI 風險管理框架 (NIST AI RMF)",
    description: "美國國家標準暨技術研究院發布的 AI 風險管理框架，國際公認的 AI 治理標準。",
    url: "https://www.nist.gov/itl/ai-risk-management-framework",
    category: "國際標準",
    icon: "ri-shield-check-line",
  },
  {
    id: "l5",
    title: "歐盟 AI 法案 (EU AI Act)",
    description: "全球首部全面性 AI 監管法規，規範 AI 系統的風險分級與合規要求。",
    url: "https://digital-strategy.ec.europa.eu/en/policies/regulatory-framework-ai",
    category: "國際標準",
    icon: "ri-file-text-line",
  },
  {
    id: "l6",
    title: "Partnership on AI",
    description: "全球 AI 倫理與社會影響的非營利合作組織，由 Amazon、Google、Meta 等共同發起。",
    url: "https://partnershiponai.org",
    category: "國際組織",
    icon: "ri-global-line",
  },
  {
    id: "l7",
    title: "IEEE AI 標準委員會",
    description: "制定 AI 系統設計、開發與部署的國際技術標準與倫理指引。",
    url: "https://ethicsinaction.ieee.org",
    category: "國際組織",
    icon: "ri-award-line",
  },
  {
    id: "l8",
    title: "AI 開放資料平台 (data.gov.tw)",
    description: "政府開放資料平台，提供 AI 訓練與應用所需的公開資料集。",
    url: "https://data.gov.tw",
    category: "資料與工具",
    icon: "ri-database-2-line",
  },
  {
    id: "l9",
    title: "Hugging Face",
    description: "全球最大的開源 AI 模型與資料集社群平台，提供預訓練模型與開發工具。",
    url: "https://huggingface.co",
    category: "資料與工具",
    icon: "ri-code-box-line",
  },
  {
    id: "l10",
    title: "台灣 AI 實驗室 (Taiwan AI Labs)",
    description: "台灣最具代表性的 AI 研究機構，推動醫療 AI、智慧城市與自然語言處理研究。",
    url: "https://ailabs.tw",
    category: "產學資源",
    icon: "ri-flask-line",
  },
  {
    id: "l11",
    title: "工研院人工智慧系統研究所",
    description: "工研院專責 AI 技術研發與產業應用推動，提供技術諮詢與合作機會。",
    url: "https://www.itri.org.tw",
    category: "產學資源",
    icon: "ri-lightbulb-flash-line",
  },
  {
    id: "l12",
    title: "台灣人工智慧學校",
    description: "由中研院與產業界共同創辦的 AI 人才培育機構，提供技術經理人培訓課程。",
    url: "https://aiacademy.tw",
    category: "產學資源",
    icon: "ri-school-line",
  },
];

export const linkCategories = [
  { key: "all", label: "全部連結" },
  { key: "政府單位", label: "政府單位" },
  { key: "國際標準", label: "國際標準" },
  { key: "國際組織", label: "國際組織" },
  { key: "資料與工具", label: "資料與工具" },
  { key: "產學資源", label: "產學資源" },
];